import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from "react-redux";
import store from "./store";
import axios from "./net/axios";

import config from './config';
const {baseUrl} = config.api;

/** Intercept any unauthorized request.
* dispatch logout action accordingly */
const UNAUTHORIZED = 401;
axios.interceptors.response.use(
  response => response,
  error => {
    const {status} = error.response;
    if (status === UNAUTHORIZED) {
      if (error.response.config.url.startsWith(baseUrl)) {
        window.location.href="/logout";
      }
    }
   return Promise.reject(error);
 }
);

ReactDOM.render(
  <React.Fragment>
  <Provider store={store}>
    <App />
    </Provider>
  </React.Fragment>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
